import { ProductFormBase } from './product-form-class.js';

import '../../styles/components/product-form.scss';
import '../../styles/components/product-card-form.scss';

class ProductCardFormElement extends ProductFormBase {
  constructor() {
    super();

    this.imagesWrapper = this.productWrapper.querySelector('[data-images]');
    this.mainImage = this.imagesWrapper.querySelector('[data-variant-image="main"]');
    this.hoverImage = this.imagesWrapper.querySelector('[data-hover-image]');
    this.swatchListenersAdded = false;
    
    if (!this.product) {
      this.product = this.getProductJson();
    }
  }

  async initializeForm() {
    await super.initializeForm();
    this.ensureSwatchListenersSetup();
  }

  ensureSwatchListenersSetup() {
    if (!this.swatchListenersAdded && this.product && this.product.variants) {
      this.setupSwatchHoverListeners();
      this.swatchListenersAdded = true;
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.ensureSwatchListenersSetup();
    }, 100);
  }

  setupSwatchHoverListeners() {
    const colorSwatches = this.querySelectorAll('[data-is-color]');
    
    if (colorSwatches.length === 0) {
      return;
    }
    
    colorSwatches.forEach(swatch => {
      const swatchLabel = swatch.closest('.swatches__swatch');
      
      if (swatchLabel) {
        swatchLabel.addEventListener('mouseenter', () => {
          if (!this.product || !this.product.variants) return;
          
          const optionValue = swatch.value;
          const optionPosition = swatch.dataset.optionPosition;
          
          const hoverImg = this.imagesWrapper.querySelector('[data-hover-image]');
          if (hoverImg) {
            hoverImg.classList.add('hide-desktop-down');
          }
          
          let matchingVariant = null;
          
          if (optionPosition == 1) {
            matchingVariant = this.product.variants.find(variant => 
              variant.option1 === optionValue
            );
          } else if (optionPosition == 2) {
            const currentOption1 = this.querySelector('input[id^=Option1]:checked')?.value;
            matchingVariant = this.product.variants.find(variant => 
              variant.option1 === currentOption1 && 
              variant.option2 === optionValue
            );
          } else if (optionPosition == 3) {
            const currentOption1 = this.querySelector('input[id^=Option1]:checked')?.value;
            const currentOption2 = this.querySelector('input[id^=Option2]:checked')?.value;
            matchingVariant = this.product.variants.find(variant => 
              variant.option1 === currentOption1 && 
              variant.option2 === currentOption2 && 
              variant.option3 === optionValue
            );
          }
          
          if (matchingVariant && matchingVariant.featured_media) {
            this.showVariantImageOnHover(matchingVariant.id);
          }
        });
        
        swatchLabel.addEventListener('mouseleave', () => {
          if (!this.product) return;
          
          const hoverImg = this.imagesWrapper.querySelector('[data-hover-image]');
          if (hoverImg) {
            hoverImg.classList.remove('hide-desktop-down');
          }
          
          const currentVariantId = this.selectId?.value;
          if (currentVariantId) {
            const currentVariant = this.product.variants.find(v => v.id == currentVariantId);
            if (currentVariant) {
              this.updateCardImage(currentVariant);
            }
          } else {
            this.updateCardImage(null);
          }
        });
      }
    });
  }

  showVariantImageOnHover(variantId) {
    const activeImage = this.imagesWrapper.querySelector('.active');
    if (activeImage) {
      activeImage.classList.remove('active');
    }
    
    const variantImage = this.imagesWrapper.querySelector(`[data-variant-image="${variantId}"]`);
    if (variantImage) {
      variantImage.classList.add('active');
    } else {
      this.mainImage.classList.add('active');
    }
  }

  optionsChange(event) {
    let hoverImage = this.imagesWrapper.querySelector('[data-hover-image]');
    if (hoverImage) {
      hoverImage.remove();
    }
    
    let variant = event.dataset.variant;

    this.updateMainSelect(variant);
    this.updateProductPrice(variant);
    this.updateSku(variant);
    this.updateSelectedOptions(variant);
    this.updateProductButton(variant);

    this.updateCardImage(variant);
  }

  updateCardImage(variant) {
    const activeImage = this.imagesWrapper.querySelector('.active');
    if (activeImage) {
      activeImage.classList.remove('active');
    }

    if (variant && variant.featured_media) {
      const newImage = this.imagesWrapper.querySelector(`[data-variant-image="${variant.id}"]`);
      if (newImage) {
        newImage.classList.add('active');
      } else {
        this.mainImage.classList.add('active');
      }
    } else {
      this.mainImage.classList.add('active');
    }
  }
}

try {
  customElements.define('product-card-form', ProductCardFormElement);
}
catch(e) {}
